import { createSlice } from '@reduxjs/toolkit';
import { Sentry } from 'root/utils/raven';

const initialState = {
  devices: {},
  isLoading: false,
  error: null
};

const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    getDevicesStart(state) {
      state.isLoading = true;
    },
    getDevicesSuccess(state, { payload }) {
      state.devices = payload;
      state.isLoading = false;
      state.error = null;
    },
    getDevicesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getDevicesStart,
  getDevicesSuccess,
  getDevicesFailure,
} = devicesSlice.actions;

export default devicesSlice.reducer;

export const fetchDevices = (query) => async (dispatch, getState) => {
  const { devices } = getState();
  if (!devices.devices?.length) {
    try {
      dispatch(getDevicesStart());
      dispatch(getDevicesSuccess({ isPhone: query.isPhone || null, isTablet: query.isTablet || null, isDesktop: query.isDesktop || null }));
    } catch (e) {
      dispatch(getDevicesFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};
